module.exports = __webpack_public_path__ + "static/cra-14c692a268748b398922212eaeb336fa.png";